import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import {DEGREE_SIGN, MELTING_TEMP_ABBREVIATION} from 'util/UnicodeSymbols';

interface PrimerPairMaxMeltingTempDifferenceProps {
  primerPairMaxMeltingTempDifference: number | null;
  updatePrimerPairMaxMeltingTempDifference: (primerPairMaxMeltingTempDifference: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input to set maximum melting temperature difference between primer pairs for bulk assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.primerPairMaxMeltingTempDifference The maximum difference, in degrees Celsius, between the melting temperatures of all primers used in this assembly.
 * @param {function} props.updatePrimerPairMaxMeltingTempDifference A function to take a temp difference and use it to update state.
 * @constructor
 */
export function PrimerPairMaxMeltingTempDifference(
  props: PrimerPairMaxMeltingTempDifferenceProps
): JSX.Element {
  return (
    <InputWrapper
      id="primerPairMaxMeltingTempDifference"
      label={`Max. ${MELTING_TEMP_ABBREVIATION} difference between primer pairs (${DEGREE_SIGN}C)`}
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.primerPairMaxMeltingTempDifference}
        min={0}
        required={true}
        onChange={(e) => {
          props.updatePrimerPairMaxMeltingTempDifference(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
